import { SvgIcon } from '@avantia/style-guide';
import type { HpSvgIconTypes } from '@avantia/style-guide';

import './toggleMessages.scss';

interface ToggleMessagesProps {
  messageList: ToggleMessageList[];
  styles: string;
  messageTitle: string;
}

export interface ToggleMessageList {
  icon: string;
  text: string;
}

export const ToggleMessages = ({ messageList, styles, messageTitle }: ToggleMessagesProps): JSX.Element => {
  return (
    <div className={styles}>
      <p className="warnings-title av-text-large">{messageTitle}</p>
      <div>
        {messageList.map((message, index) => (
          <div key={index} className="message">
            <SvgIcon type={message.icon as HpSvgIconTypes} size="very-tiny" />
            <p id={`helper-text-${index}`}>{message.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
